import { flow, types, applySnapshot } from 'mobx-state-tree';

import api from '../utils/api';
import NextPreviewStore from './NextPreviewStore';

export default types
  .model('Jobs', {
    photo: types.optional(types.map(types.frozen), {}),
    vacancies: types.optional(types.array(types.frozen), []),
    nextPreview: NextPreviewStore,
  })
  .actions(self => ({
    load: flow(function* load() {
      const response = yield api.jobs();
      applySnapshot(self, yield response.json());
    }),
  }))
  .views(self => ({
    get vacanciesByCategory() {
      return self.vacancies.reduce((acc, vacancy) => {
        let group;
        const filtered = acc.filter(group => group.name === vacancy.category.name);
        if (filtered.length === 0) {
          group = { name: vacancy.category.name, items: [] };
          acc.push(group);
        } else {
          group = filtered[0];
        }

        group.items.push(vacancy);

        return acc;
      }, []);
    },
  }));



// WEBPACK FOOTER //
// ./src/stores/JobsStore.js